export const svData = {
  title: "Integritets- och cookiepolicy – Danghuan",
  sections: [
    {
      title: "Introduktion",
      content: `
        <p>Denna integritets- och cookiepolicy förklarar hur Danghuan Europe S.L. ('vi', 'oss' eller 'Danghuan') samlar in, använder och skyddar dina personuppgifter när du interagerar med våra webbplatser och tjänster. Denna policy gäller för invånare inom Europeiska ekonomiska samarbetsområdet (EES) och Förenade kungariket (UK) och följer EU:s allmänna dataskyddsförordning (GDPR) samt Storbritanniens dataskyddslagstiftning (UK GDPR).</p>
      `
    },
    {
      title: "Policyns tillämpningsområde",
      content: `
        <p>Denna policy gäller för:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Besökare på vår webbplats (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Kunder och potentiella kunder</li>
          <li style='margin-bottom: 8px;'>Användare av våra inbytes- och återförsäljningstjänster</li>
          <li style='margin-bottom: 8px;'>Representanter för affärspartners och plattformsanslutna företag</li>
        </ul>
      `
    },
    {
      title: "Vilka uppgifter vi samlar in",
      content: `
        <p>Beroende på hur du interagerar med oss kan vi samla in följande:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Fullständigt namn, adress, e-postadress och telefonnummer</li>
          <li style='margin-bottom: 8px;'>IBAN, sorteringskod och kontonummer, PayPal, Revolut eller andra bankuppgifter</li>
          <li style='margin-bottom: 8px;'>Enhetsinformation (modell, märke, skick, prisinformation, IMEI)</li>
          <li style='margin-bottom: 8px;'>Kommunikationshistorik med kundtjänst</li>
          <li style='margin-bottom: 8px;'>Marknadsföringspreferenser och kampanjinteraktioner</li>
          <li style='margin-bottom: 8px;'>IP-adress, webbläsartyp, sessions-ID och platsinformation</li>
          <li style='margin-bottom: 8px;'>Plattformdata från Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>Vi kan även ta emot vissa uppgifter om dig från våra plattforms- eller logistikpartner (t.ex. Shopify, Amazon, Back Market, TEMU) när du interagerar med deras plattformar i samband med våra tjänster. Detta inkluderar orderinformation, leveransadress och transaktionsstatus.</p>
      `
    },
    {
      title: "Användning av personuppgifter",
      content: `
        <p>Vi använder dina personuppgifter för att:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Behandla och slutföra dina inbytes-, försäljnings- eller serviceförfrågningar</li>
          <li style='margin-bottom: 8px;'>Kommunicera med dig angående orderstatus, leveransinformation eller supportärenden</li>
          <li style='margin-bottom: 8px;'>Förbättra vår kundservice, operativ effektivitet och användarupplevelse</li>
          <li style='margin-bottom: 8px;'>Uppfylla lagstadgade och regulatoriska skyldigheter, inklusive redovisnings-, skatte- och rapporteringskrav</li>
          <li style='margin-bottom: 8px;'>Analysera och övervaka användningen av våra tjänster för att förhindra bedrägerier eller missbruk</li>
          <li style='margin-bottom: 8px;'>Kommunicera med dig om kampanjer, serviceuppdateringar eller ändringar i villkor, när det är relevant och lagligt</li>
        </ul>
      `
    },
    {
      title: "Cookies",
      content: `
        <p>Vi använder cookies för att förbättra din webbläsarupplevelse och optimera våra tjänster. Cookies kan samla in:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>IP-adress och geografisk plats</li>
          <li style='margin-bottom: 8px;'>Identifierare för webbläsare/enheter</li>
          <li style='margin-bottom: 8px;'>Användarbeteende (visade sidor, tid på webbplatsen, klick)</li>
        </ul>
        <p>Typer av cookies:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Strikt nödvändiga cookies</li>
          <li style='margin-bottom: 8px;'>Funktionella cookies</li>
          <li style='margin-bottom: 8px;'>Prestandacookies</li>
          <li style='margin-bottom: 8px;'>Reklamcookies</li>
        </ul>
        <p>Du kan när som helst konfigurera eller återkalla dina cookieinställningar via din webbläsare eller cookie-bannern.</p>
      `
    },
    {
      title: "Tredje parter som vi delar data med",
      content: `
        <p>Vi delar data med betalnings- och logistikpartner baserat på avtalsmässigt behov samt med analysleverantörer baserat på ditt samtycke till cookies.</p>
        <p>Vi kan dela dina uppgifter med:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Betalningspartner: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li style='margin-bottom: 8px;'>Logistikleverantörer: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Plattformspartner: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Leverantörer av marknadsföring och analys: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li style='margin-bottom: 8px;'>IT-leverantörer, konsulter och juridiska rådgivare</li>
          <li style='margin-bottom: 8px;'>Myndigheter, om det krävs enligt lag</li>
        </ul>
        <p>Data kan överföras utanför EES eller Storbritannien enligt EU-godkända skyddsåtgärder, såsom Standardavtalsklausuler (Standard Contractual Clauses).</p>
      `
    },
    {
      title: "Användning av tredjeparts varumärkeslogotyper",
      content: `
        <p>Vår webbplats visar varumärkesnamn och logotyper som Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google och andra enbart i syfte att identifiera kompatibla enheter för inbytes- eller återförsäljningsändamål. Alla varumärken tillhör sina respektive ägare. Danghuan Europe är en oberoende tjänsteleverantör och är inte associerad med, godkänd av eller sponsrad av dessa varumärken, om inte detta uttryckligen anges.</p>
        <p>Användningen av tredjeparts varumärkeslogotyper är uteslutande för beskrivande syften. Alla dessa varumärken behåller sina respektive rättigheter, och ingen koppling till Danghuan är underförstådd.</p>
      `
    },
    {
      title: "Datalagring och säkerhet",
      content: `
        <p>Vi behåller dina uppgifter endast så länge det är nödvändigt för att uppfylla ovanstående syften eller som krävs enligt lag. Vi använder lämpliga tekniska och organisatoriska åtgärder för att skydda dina uppgifter, inklusive kryptering, åtkomstkontroller och säker lagring.</p>
      `
    },
    {
      title: "Dina rättigheter",
      content: `
        <p>Vi strävar efter att besvara alla giltiga begäranden om dataåtkomst inom en månad. För att skydda din integritet kan vi behöva verifiera din identitet innan vi behandlar din begäran.</p>
        <p>Du har rätt att:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Få tillgång till och rätta dina uppgifter</li>
          <li style='margin-bottom: 8px;'>Begära radering ("rätten att bli bortglömd")</li>
          <li style='margin-bottom: 8px;'>Invända mot eller begränsa behandlingen</li>
          <li style='margin-bottom: 8px;'>När som helst återkalla ditt samtycke</li>
          <li style='margin-bottom: 8px;'>Begära dataportabilitet (när det är tillämpligt)</li>
        </ul>
        <p>För att utöva dessa rättigheter, kontakta oss på <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: "Uppdateringar av policyn",
      content: `
        <p>Vi kan uppdatera denna policy för att återspegla förändringar i lagkrav eller i våra databehandlingsrutiner. Den senaste versionen kommer alltid att finnas tillgänglig på vår webbplats.</p>
      `
    },
    {
      title: "Kontakta oss",
      content: `
        <p>Om du har frågor eller vill utöva dina rättigheter, vänligen kontakta oss:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'><strong>Danghuan Europe S.L.</strong></li>
          <li style='margin-bottom: 8px;'><strong>E-post:</strong> <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'><strong>Webbplats:</strong> <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>Du kan också lämna in ett klagomål till din lokala dataskyddsmyndighet eller till den Spanska Dataskyddsmyndigheten (AEPD).</p>
      `
    },
    {
      title: "Tillägg – Utökad juridisk och cookieinformation",
      subsections: [
        {
          title: "1. Rättslig grund för databehandling",
          content: `
            <p>Den rättsliga grunden för behandlingen av dina personuppgifter inkluderar:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Utförande av ett avtal (t.ex. behandling av inbytesorder, utbetalningar)</li>
              <li style='margin-bottom: 8px;'>Efterlevnad av rättsliga skyldigheter (t.ex. skatteredovisning, identitetsverifiering)</li>
              <li style='margin-bottom: 8px;'>Ditt samtycke (t.ex. marknadskommunikation eller tredjepartscookies)</li>
              <li style='margin-bottom: 8px;'>Berättigade intressen (t.ex. bedrägeriförebyggande, intern analys, förbättring av tjänster)</li>
            </ul>
          `
        },
        {
          title: "2. Åtgärder för att förebygga bedrägerier",
          content: `
            <p>Vi kan använda dina personuppgifter (t.ex. enhetens serienummer, transaktionsmönster, IP-geolokalisering, IBAN-innehav) för att utföra bedrägerikontroller med hjälp av offentligt tillgängliga databaser och leverantörer av bedrägeribekämpningstjänster. Detta sker inom ramen för vårt berättigade intresse att förhindra identitetsstöld och missbruk av våra tjänster.</p>
            <p>Vi fattar inte beslut som enbart baseras på automatiserad behandling som kan påverka dig i betydande grad.</p>
          `
        },
        {
          title: "3. Hantering av data på externa marknadsplatser",
          content: `
            <p>Om du köper eller säljer enheter via tredjepartsplattformar som Amazon, Shopify, TEMU eller Back Market, kan Danghuan ta emot din orderinformation, leveransadress och betalningsbekräftelse via ett krypterat API eller en säker backoffice-kanal. Detta sker uteslutande i syfte att genomföra din transaktion och tillhandahålla support efter försäljningen.</p>
          `
        },
        {
          title: "4. Kategorier och detaljer om cookies",
          content: `
            <p>Du kan granska den fullständiga listan över cookies som vi använder — inklusive namn, leverantör, syfte, varaktighet och typ (förstapart eller tredjepart) — i tabellen nedan. Detta inkluderar analyscookies från Google Analytics, retargeting-cookies från Meta, och betalningscookies från PayPal.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Kategori</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Cookiens namn</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Leverantör</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Syfte</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Varaktighet</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Typ</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strikt Nödvändig</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Lagrar cookie-inställningar</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 år</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Förstapart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strikt Nödvändig</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Uppehåller sessionstillstånd mellan sidor</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Förstapart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funktionell</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Kommer ihåg valt språk</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Session</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Förstapart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funktionell</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Möjliggör live-chattsupport</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 månader</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prestanda</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Samlar in webbplatsstatistik</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 år</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prestanda</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Spårar användarbeteende mellan sessioner</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 timmar</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Prestanda</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Uppehåller användarsession mellan sidor</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 år</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklam</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Levererar personifierade annonser baserat på beteende</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 månader</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklam</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Spårar användarinteraktioner och konverteringar</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 månader</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklam</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Spårar användare mellan webbplatser för marknadsföring</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 dag</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklam</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Används för konverteringsspårning</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 månader</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklam</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Identifierar besökare för e-postmarknadsföringskampanjer</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 år</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tredjepart</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: "5. Kampanjer, undersökningar och enkäter",
          content: `
            <p>När du deltar i våra kampanjer, undersökningar eller tävlingar kan vi samla in ditt namn, dina kontaktuppgifter och ytterligare information som är specifik för evenemanget (t.ex. ålder, plats). Dessa uppgifter används enbart för att administrera evenemanget, kontakta vinnare och förbättra framtida kampanjer.</p>
          `
        },
        {
          title: "6. Tillsynsmyndigheter",
          content: `
            <p>Du kan lämna in ett klagomål till följande tillsynsmyndigheter om du anser att dina dataskyddsrättigheter har överträtts:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>I Sverige: Integritetsskyddsmyndigheten (IMY) – <a href="https://www.imy.se" target="_blank">www.imy.se</a></li>
              <li style='margin-bottom: 8px;'>Inom Europeiska unionen: du kan hitta den relevanta nationella tillsynsmyndigheten för ditt land på webbplatsen för European Data Protection Board (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};